import {
  INITIALIZE_OPEN_ORDERS,
  UPDATE_OPEN_ORDERS,
  LOAD_TRADE_HISTORY,
  LOAD_ORDER_HISTORY,
  SET_PERCENT_AMOUNT,
  CANCEL_ORDER_PROCESS_STARTED,
  CANCEL_ORDER_PROCESS_FINISHED,
  NEW_ORDER_HISTORY_LOADING_STARTED,
  NEW_ORDER_HISTORY_LOADING_FINISHED,
  NEW_ORDER_HISTORY_LOADED,
  MY_TRADE_HISTORY_LOADING_STARTED,
  MY_TRADE_HISTORY_LOADING_FINISHED,
  MY_TRADE_HISTORY_LOADED,
} from 'redux/actions/orders';
import { USER_LOGOUT_STARTED } from 'redux/actions/profile';

const initialState = {
  isOpenOrdersLoading: true,
  openOrders: [],
  isTradeHistoryLoading: true,
  tradeHistory: [],
  isOrderHistoryLoading: true,
  orderHistory: [],
  cancelableOrderId: null,
  newOrderHistoryIsLoading: false,
  newOrderHistory: [],
  orderHistoryPagination: {
    currentPage: 1,
    limit: 25,
    pagesAmount: 1,
  },
  myTradeHistoryIsLoading: false,
  myTradeHistory: [],
  myTradeHistoryPagination: {
    currentPage: 1,
    limit: 25,
    pagesAmount: 1,
  },
  percentAmount: {
    sellValue: undefined,
    buyValue: undefined,
    buyMarketValue: undefined,
  },
};

export const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_OPEN_ORDERS:
      return { ...state, openOrders: action.payload };
    case UPDATE_OPEN_ORDERS:
      return { ...state, openOrders: action.payload };
    case LOAD_TRADE_HISTORY.STARTED:
      return { ...state, isTradeHistoryLoading: true };
    case LOAD_TRADE_HISTORY.SUCCESS:
      return {
        ...state,
        isTradeHistoryLoading: false,
        tradeHistory: action.payload,
      };
    case LOAD_TRADE_HISTORY.FAIL:
      return { ...state, isTradeHistoryLoading: false };
    case LOAD_ORDER_HISTORY.STARTED:
      return { ...state, isOrderHistoryLoading: true };
    case LOAD_ORDER_HISTORY.SUCCESS:
      return {
        ...state,
        isOrderHistoryLoading: false,
        orderHistory: action.payload,
      };
    case LOAD_ORDER_HISTORY.FAIL:
      return { ...state, isOrderHistoryLoading: false };
    case SET_PERCENT_AMOUNT:
      return {
        ...state,
        percentAmount: {
          // ...state.percentAmount,
          [action.payload.side]: action.payload.amount,
          [`${action.payload.side}Timestamp`]: Date.now(),
          value: action.payload.amount,
          totalValue: action.payload.totalValue,
        },
      };
    case USER_LOGOUT_STARTED:
      return { ...initialState };
    case CANCEL_ORDER_PROCESS_STARTED:
      return { ...state, cancelableOrderId: action.payload };
    case CANCEL_ORDER_PROCESS_FINISHED:
      return { ...state, cancelableOrderId: null };
    case NEW_ORDER_HISTORY_LOADING_STARTED:
      return { ...state, newOrderHistoryIsLoading: true };
    case NEW_ORDER_HISTORY_LOADING_FINISHED:
      return { ...state, newOrderHistoryIsLoading: false };
    case NEW_ORDER_HISTORY_LOADED:
      return {
        ...state,
        newOrderHistory: action.payload.items,
        orderHistoryPagination: {
          currentPage: action.payload.currentPage,
          limit: action.payload.limit,
          pagesAmount: action.payload.pagesAmount,
        },
      };
    case MY_TRADE_HISTORY_LOADING_STARTED:
      return { ...state, myTradeHistoryIsLoading: true };
    case MY_TRADE_HISTORY_LOADING_FINISHED:
      return { ...state, myTradeHistoryIsLoading: false };
    case MY_TRADE_HISTORY_LOADED:
      return {
        ...state,
        myTradeHistory: action.payload.rows,
        myTradeHistoryPagination: {
          currentPage: action.payload.currentPage,
          limit: action.payload.limit,
          pagesAmount: action.payload.pagesAmount,
        },
      };
    default:
      return state;
  }
};
